<template>
    <div class="ele-body">
        <el-card shadow="never" body-style="padding-top: 5px;">
            <el-tabs  v-model="active" class="user-info-tabs">
                <el-tab-pane label="隐私协议" name="info" style="padding-top: 20px;">
                    <!-- 编辑弹窗 -->
                    <ikz-size></ikz-size>
                </el-tab-pane>
                <el-tab-pane label="隐私协议2" name="info2" style="padding-top: 20px;">
                    <!-- 编辑弹窗 -->
                    <ikz-color v-if="active == 'info2'"></ikz-color>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
    import ikzColor from '@/views/campus/campusschool/index'
    import ikzSize from '@/views/house/housesize/size'
    import {
        mapGetters
    } from "vuex";


    export default {
        name: "SysHouseSize",
        components: {
            ikzColor,
            ikzSize
        },
        data() {
            return {
                active: 'info',
                table: {
                    url: '/house/HouseSize/index',
                    where: {
                        "hall_tag": [],
                        "room_tag": [],
                        "defend_tag": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "hall_tag": [],
                    "room_tag": [],
                    "defend_tag": []
                }, // 表单数据
                editFormTemp: {
                    "hall_tag": [],
                    "room_tag": [],
                    "defend_tag": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                editRules: { // 表单验证规则



                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {
            this.edit();
        },
        methods: {

            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit() {
                this.$http.get('/house/HouseSize/info?id=1').then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/house/HouseSize/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的户型吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/house/HouseSize/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/house/HouseSize/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids = this.choose.map(d => d.id)
                if (ids.length == 0) {
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/house/HouseSize/exportExcel", {
                        id: ids
                    })
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            /**
             * 添加标签
             */
            addTips(format, item) {
                if (this.editForm[item]) {
                    this.editForm[format].push(this.editForm[item]);
                    this.editForm[item] = '';
                }
            },
            /**
             * 删除标签
             */
            deleteTips(format, index) {
                this.editForm[format].splice(index, 1);
            },


        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
